/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AccountsTypes = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16;

export const AccountsTypes = {
    NUMBER_1: 1 as AccountsTypes,
    NUMBER_2: 2 as AccountsTypes,
    NUMBER_3: 3 as AccountsTypes,
    NUMBER_4: 4 as AccountsTypes,
    NUMBER_5: 5 as AccountsTypes,
    NUMBER_6: 6 as AccountsTypes,
    NUMBER_7: 7 as AccountsTypes,
    NUMBER_8: 8 as AccountsTypes,
    NUMBER_9: 9 as AccountsTypes,
    NUMBER_10: 10 as AccountsTypes,
    NUMBER_11: 11 as AccountsTypes,
    NUMBER_12: 12 as AccountsTypes,
    NUMBER_13: 13 as AccountsTypes,
    NUMBER_14: 14 as AccountsTypes,
    NUMBER_15: 15 as AccountsTypes,
    NUMBER_16: 16 as AccountsTypes
};

